import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function CitePage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Citation</b>
        </h2>
      }
      text_content={
        <div>
          <br />{" "}
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ol>
                <li>
                  <div
                    className="style40"
                    onClick={() => {
                      navigator.clipboard.writeText(this.state.textToCopy);
                    }}
                  >
                    <strong>Citation :</strong>&nbsp;Ramachandra T.V., Paras
                    Negi, Tulika Mondal and Syed Ashfaq Ahmed, 2025. Insigts
                    into the linkages of forest structure dynamics with
                    ecosystem services, <i>Scientific Reports</i> 15, Article
                    number: 15606{" "}
                    <a href="https://doi.org/10.1038/s41598-025-00167-3">
                      | https://doi.org/10.1038/s41598-025-00167-3
                    </a>
                  </div>
                  <div className="style39">&nbsp;</div>
                  <div className="style39">
                    <table width="100%" cellspacing="0" cellpadding="0">
                      <tbody>
                        <tr>
                          <td colspan="4" height="30">
                            <span className="style40">
                              <strong>* Corresponding Author :</strong>
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td width="9%" height="104">
                            &nbsp;
                          </td>
                          <td width="91%">
                            <span className="style40">
                              <strong>Dr. T.V. Ramachandra</strong>
                              <br />
                              Energy &amp; Wetlands Research Group, Centre for
                              Ecological Sciences, Indian Institute of Science,
                              Bangalore &ndash; 560 012, India.
                              <br />
                              Tel : +91-80-2293 3099/2293 3503 [extn - 107],
                              &nbsp;&nbsp;&nbsp;&nbsp; Fax : 91-80-23601428 /
                              23600085 / 23600683 [CES-TVR]
                              <br />
                              E-mail :&nbsp;
                              <a
                                title="mailto:tvr@iisc.ac.in"
                                href="mailto:tvr@iisc.ac.in"
                              >
                                tvr@iisc.ac.in
                              </a>
                              ,&nbsp;
                              <a
                                title="mailto:energy@.iisc.ac.in"
                                href="mailto:energy@.iisc.ac.in"
                              >
                                energy@ces.iisc.ac.in
                              </a>
                              ,&nbsp;&nbsp;&nbsp;&nbsp; Web :&nbsp;
                              <a
                                title="https://wgbis.ces.iisc.ac.in/energy"
                                href="https://wgbis.ces.iisc.ac.in/energy"
                                target="_blank"
                              >
                                https://wgbis.ces.iisc.ac.in/energy
                              </a>
                              ,&nbsp;
                              <a
                                title="https://wgbis.ces.iisc.ac.in/grass"
                                href="https://wgbis.ces.iisc.ac.in/grass"
                                target="_blank"
                              >
                                https://wgbis.ces.iisc.ac.in/grass
                              </a>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
              </ol>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default CitePage;
